import React from 'react';
import {Checkbox} from 'antd';
import Button from '@common/Button';
import Tag from '@common/Tag';
import {VisibilityRounded} from '@mui/icons-material';

const TYPE_PILL_COLORS = {
    scorcher: 'volcano',
    game: 'default',
    desmos: 'blue',
};

const TAG_COLORS = {
    fluency: 'gold',
    'problem-solving': 'blue',
    reasoning: 'green',
    enrichment: 'volcano',
    scorcher: 'volcano',
    game: 'default',
    desmos: 'blue',
};

const ReviewItemCard = ({
    id,
    text,
    checked,
    onToggle,
    onPreview,
    icon,
    typePill,
    meta,
    tags,
    steps,
    summary,
}) => (
    <div className={`ch-lesson-planner-review-item-card${checked ? ' ch-lesson-planner-review-item-card--checked' : ''}${onPreview ? ' ch-lesson-planner-review-item-card--has-preview' : ''}`}>
        <Checkbox
            className="ch-lesson-planner-review-item-card__checkbox"
            checked={checked}
            onChange={() => onToggle(id)}
        >
            {icon && (
                <div className="ch-lesson-planner-review-item-card__icon-tile">{icon}</div>
            )}
            <div className="ch-lesson-planner-review-item-card__body">
                <div className="ch-lesson-planner-review-item-card__top">
                    <span className="ch-lesson-planner-review-item-card__title">{text}</span>
                    {typePill && (
                        <Tag color={TYPE_PILL_COLORS[typePill.toLowerCase()] ?? 'default'}>
                            {typePill}
                        </Tag>
                    )}
                </div>

                {meta && (
                    <span className="ch-lesson-planner-review-item-card__meta">{meta}</span>
                )}

                {tags?.length > 0 && (
                    <div className="ch-lesson-planner-review-item-card__tags">
                        {tags.map(tag => (
                            <Tag key={tag.label} color={TAG_COLORS[tag.variant] ?? 'default'}>
                                {tag.label}{tag.count != null ? ` · ${tag.count}` : ''}
                            </Tag>
                        ))}
                    </div>
                )}

                {steps > 0 && (
                    <div className="ch-lesson-planner-review-item-card__step-track">
                        {Array.from({length: steps}).map((_, i) => (
                            <div key={i} className="ch-lesson-planner-review-item-card__step-seg" />
                        ))}
                    </div>
                )}

                {summary && (
                    <p className="ch-lesson-planner-review-item-card__summary">{summary}</p>
                )}
            </div>
        </Checkbox>
        
        {onPreview && (
            <div className="ch-lesson-planner-review-item-card__preview-wrap">
                <Button
                    type="text"
                    htmlType="button"
                    className="ch-lesson-planner-review-item-card__preview-btn"
                    icon={<VisibilityRounded />}
                    aria-label={`Preview: ${text}`}
                    onClick={() => onPreview(id)}
                >
                    Preview
                </Button>
            </div>
        )}
    </div>
);

export default ReviewItemCard;
